import {
  StockStatuses,
  type ProductCardProps
} from '@dcxwam/dcx-wam-ui-foundations'
import { MAX_COLORS_PER_VIEW } from './color'
import { getMatchedVariant, HistoryFilter } from './filter'
import { type Stocks, getStockLevelStatus, stockStatusMap } from './stock'
import type { Item } from '../models'

type ColorSelector = {
  variants: Item[]
  stocks: Stocks
  historyFilters: HistoryFilter[]
  dotsVisibility: boolean
}

const getColorVariants = (variants: Item[], stocks: Stocks) =>
  Object.values<NonNullable<ProductCardProps['colorSelector']>>(
    variants.reduce((acc, variant) => {
      const nuanceCode = variant.nuance?.code
      let currentStock = stockStatusMap[getStockLevelStatus(variant, stocks)]

      if (nuanceCode && currentStock === StockStatuses.OutOfStock) {
        const hasStockByNuanceCode = variants
          .filter((v) => v.nuance?.code === nuanceCode)
          .some(
            ({ stock: { stockLevelStatus }, globalArticleCode }) =>
              stockStatusMap[
                stocks[globalArticleCode]?.stockLevelStatus || stockLevelStatus
              ] !== StockStatuses.OutOfStock
          )
        currentStock = hasStockByNuanceCode
          ? StockStatuses.InStock
          : StockStatuses.OutOfStock
      }

      return nuanceCode
        ? {
            ...acc,
            [nuanceCode]: {
              colorLabel: variant.nuance?.description,
              value: nuanceCode,
              colorHex: variant.nuance?.hexCode,
              stock: currentStock,
              'aria-label': variant.nuance?.description
            }
          }
        : acc
    }, {})
  )

export const getColorSelector = ({
  variants,
  stocks,
  historyFilters,
  dotsVisibility = false
}: ColorSelector) => {
  const matchedVariant = getMatchedVariant(variants, historyFilters)

  return dotsVisibility
    ? {
        maxColorsPerView: MAX_COLORS_PER_VIEW,
        currentValue: matchedVariant?.nuance?.code,
        colorVariants: getColorVariants(variants, stocks)
      }
    : undefined
}
